import React, { useState, useEffect } from "react";
import Adminnav from "../components/Adminnav";
import Layout from "../components/Layout";
import fireDB from "../fireconfig";
import {
  collection,
  getDocs,
  setDoc,
  addDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { FaEdit, FaTrash } from "react-icons/fa";

import "../assets/css/Adminproducts.scss";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const Adminproducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [editproduct, setEditproduct] = useState({
    title: "",
    description: "",
    price: 0,
    image: "",
  });
  const [add, setAdd] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      const users = await getDocs(collection(fireDB, "products"));
      const productsArray = [];
      users.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        const obj = {
          id: doc.id,
          ...doc.data(),
        };
        productsArray.push(obj);
      });
      setProducts(productsArray);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const editHandler = (product) => {
    setAdd(false);
    setEditproduct(product);
    setShow(true);
  };

  const updateproduct = async () => {
    try {
      setLoading(true);
      await setDoc(doc(fireDB, "products", editproduct.id), editproduct);
      setLoading(false);
      getData();
      toast.success("Product updated successfully");
    } catch (error) {
      toast.error("Product update failed");
      setLoading(false);
    }
    setShow(false);
  };

  const addproduct = async () => {
    try {
      setLoading(true);
      await addDoc(collection(fireDB, "products"), editproduct);
      setLoading(false);
      getData();
      toast.success("Product added successfully");
    } catch (error) {
      toast.error("Adding product failed");
      setLoading(false);
    }
    setShow(false);
  };

  const addHandler = () => {
    setAdd(true);
    setEditproduct({
      title: "",
      description: "",
      price: 0,
      image: "",
    });
    handleShow();
  };

  const deleteproduct = async (product) => {
    try {
      setLoading(true);
      await deleteDoc(doc(fireDB, "products", product.id));
      getData();
      setLoading(false);
      toast.success("Deleted product successfully");
    } catch (error) {
      setLoading(false);
      toast.error("Delete document failed");
    }
  };

  return (
    <Layout loading={loading}>
      <Adminnav adminProducts="active" />
      <div className="admin_container">
        <div className="d-flex justify-content-between mb-3 text_button_section">
          <h4>Products</h4>
          <button className="btn btn-success" onClick={addHandler}>
            Add Product
          </button>
        </div>
        <table className="table admin_products_table">
          <thead>
            <tr>
              <th scope="col">Image</th>
              <th scope="col">Name</th>
              <th scope="col" className="text-center">
                Price
              </th>
              <th scope="col" className="text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => {
              return (
                <tr key={product.title}>
                  <td>
                    <img
                      src={product.image}
                      alt={product.title}
                      height="150"
                      width="225"
                    />
                  </td>
                  <td>
                    <p>{product.title}</p>
                    <p className="admin_products_item_description">
                      {product.description}
                    </p>
                  </td>
                  <td className="text-center">{product.price}/-</td>
                  <td className="text-center">
                    <div className="admin_product_actions">
                      <FaTrash
                        onClick={() => {
                          deleteproduct(product);
                        }}
                      />
                      <FaEdit onClick={() => editHandler(product)} />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {add === true ? "Add Product" : "Edit Product"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="place_order_section">
              <h4>Details</h4>
              <hr />
              <input
                type="text"
                className="form-control input_field"
                placeholder="Title"
                value={editproduct.title}
                onChange={(e) => {
                  setEditproduct({ ...editproduct, title: e.target.value });
                }}
              />
              <textarea
                rows={3}
                type="text"
                className="form-control input_field"
                placeholder="Description"
                value={editproduct.description}
                onChange={(e) => {
                  setEditproduct({
                    ...editproduct,
                    description: e.target.value,
                  });
                }}
              />
              <input
                type="number"
                onWheel={(e) => e.target.blur()}
                className="form-control input_field"
                placeholder="Price"
                value={editproduct.price}
                onChange={(e) => {
                  setEditproduct({ ...editproduct, price: e.target.value });
                }}
              />
              <input
                type="text"
                className="form-control input_field"
                placeholder="Image URL"
                value={editproduct.image}
                onChange={(e) => {
                  setEditproduct({ ...editproduct, image: e.target.value });
                }}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-success" onClick={handleClose}>
              Close
            </button>
            {add ? (
              <button className="btn btn-success" onClick={addproduct}>
                Add Product
              </button>
            ) : (
              <button className="btn btn-success" onClick={updateproduct}>
                Update Product
              </button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    </Layout>
  );
};

export default Adminproducts;
